import React from 'react';
import { ChevronDown } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';

const FAQPage = () => {
    const faqs = [
        {
            question: "How much does it cost to post an ad?",
            answer: "Currently, posting ads on Hotel Motel Club is completely FREE! We're running a COVID-19 Business Restart Promo where the first year is free for all advertisers. After the promo period, annual memberships are $300/year for unlimited ads, or $10 per individual ad for pay-as-you-go users."
        },
        {
            question: "How do I create an advertiser account?",
            answer: "Click on 'Post an Ad' or 'Create Free Account' and fill out the registration form with your business name, contact information, and address. Once registered, you can immediately start posting ads from your dashboard."
        },
        {
            question: "How long do listings stay active?",
            answer: "All listings remain active for 30 days from the posting date. Annual members can renew listings indefinitely at no additional cost. You can also put listings on hold or reactivate them from your dashboard."
        },
        {
            question: "Can I edit my listing after posting?",
            answer: "Yes! You can edit any of your listings at any time from your advertiser dashboard. Simply click on the listing you want to modify and make your changes."
        },
        {
            question: "What categories can I post in?",
            answer: "We offer 8 main categories: Hotel Furniture, Hotel Jobs (with subcategories for Management, Front Desk, Housekeeper, Maintenance, and Other), Housekeeping Supplies, Guest Supplies, Real Estate (For Sale, For Rent, Others), Hotel Furniture & Liquidation, Events & Announcements, and Misc."
        },
        {
            question: "Do I need an account to browse listings?",
            answer: "No account is required to browse listings. However, we do collect email addresses to provide you with relevant updates and opportunities. Advertisers must create an account to post listings."
        },
        {
            question: "What are the benefits of an annual membership?",
            answer: "Annual members get unlimited ad postings, 50% off display ads on the homepage ($50 instead of $100), priority support, and their listings appear higher in search results."
        },
        {
            question: "How do I contact a seller?",
            answer: "Each listing includes contact information provided by the advertiser. You can reach out via the email or phone number listed on the ad details page."
        },
        {
            question: "Can I delete my account?",
            answer: "Yes, you can request account deletion by contacting our support team at support@hotelmotelclub.com. Note that this will remove all your active listings."
        },
        {
            question: "Is my information secure?",
            answer: "Yes, we take security seriously. All data is encrypted and we never share your personal information with third parties without your consent. See our Privacy Policy for more details."
        }
    ];

    return (
        <Layout>
            <div data-testid="faq-page">
                {/* Hero */}
                <section className="bg-navy text-white py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Find answers to common questions about Hotel Motel Club
                        </p>
                    </div>
                </section>

                {/* FAQ Content */}
                <section className="py-16 bg-gray-50">
                    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                        <Accordion type="single" collapsible className="space-y-4">
                            {faqs.map((faq, index) => (
                                <AccordionItem 
                                    key={index} 
                                    value={`item-${index}`}
                                    className="bg-white rounded-lg shadow-sm border-none"
                                >
                                    <AccordionTrigger className="px-6 py-4 hover:no-underline">
                                        <span className="text-left font-semibold text-navy">{faq.question}</span>
                                    </AccordionTrigger>
                                    <AccordionContent className="px-6 pb-4">
                                        <p className="text-gray-600">{faq.answer}</p>
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>

                        {/* Still have questions */}
                        <div className="mt-12 text-center bg-white rounded-lg p-8 shadow-sm">
                            <h2 className="font-heading text-2xl font-bold text-navy mb-4">Still have questions?</h2>
                            <p className="text-gray-600 mb-6">
                                Can't find the answer you're looking for? Please reach out to our support team.
                            </p>
                            <a 
                                href="/contact" 
                                className="inline-block bg-gold hover:bg-amber-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
                            >
                                Contact Support
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default FAQPage;
